module.exports = __webpack_public_path__ + "static/media/wortenLogo.889c28f7.svg";